(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    function replaceTextNode(element, fromText, toText) {
      if (!element) return false;

      let changed = false;
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);

      while (walker.nextNode()) {
        const node = walker.currentNode;

        if (node.nodeValue && node.nodeValue.toLowerCase().includes(fromText.toLowerCase())) {
          node.nodeValue = node.nodeValue.replace(new RegExp(fromText, 'gi'), toText);
          changed = true;
        }
      }

      return changed;
    }

    function addMobileMenuGiftIcon(element, icon) {
      if (!element || element.querySelector('.bx-mobile-menu-gift-icon')) return;

      const iconSpan = document.createElement('span');
      iconSpan.className = 'bx-mobile-menu-gift-icon';
      iconSpan.setAttribute('aria-hidden', 'true');
      iconSpan.textContent = icon;

      element.insertBefore(iconSpan, element.firstChild);
    }

    function updateMobileGiftLabels() {
      const menuItems = document.querySelectorAll(
        '.menu-drawer a, .menu-drawer summary, .menu-drawer .list-menu__item, .menu-drawer__menu-item'
      );

      menuItems.forEach((item) => {
        const text = item.textContent.trim().replace(/\s+/g, ' ').toLowerCase();

        if (text.includes('corporate gifts')) {
          replaceTextNode(item, 'Corporate Gifts', 'Bulk Gifting');
          addMobileMenuGiftIcon(item, '📦');
        }

        if (text.includes('corporate gifting')) {
          replaceTextNode(item, 'Corporate Gifting', 'Bulk Gifting');
          addMobileMenuGiftIcon(item, '📦');
        }

        if (text.includes('bulk gifts')) {
          replaceTextNode(item, 'Bulk Gifts', 'Bulk Gifting');
          addMobileMenuGiftIcon(item, '📦');
        }

        if (text.includes('bulk gifting')) {
          addMobileMenuGiftIcon(item, '📦');
        }

        if (text.includes('personalized gifts')) {
          addMobileMenuGiftIcon(item, '🎀');
        }
      });
    }

    updateMobileGiftLabels();

    const menuDrawerObserver = new MutationObserver(() => {
      updateMobileGiftLabels();
    });

    menuDrawerObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });


  } catch(e) { console.error(e); }
})();
})();
